var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFlightSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7383 3.8718C13.7377 4.15741 13.6337 4.44282 13.4263 4.66073L10.9079 7.30725C10.6361 7.5929 10.1954 7.59289 9.92359 7.30725C9.65177 7.02161 9.65177 6.5585 9.92359 6.27286L11.515 4.60054L0.868898 4.60054C0.484599 4.60054 0.173062 4.27316 0.173063 3.86931C0.173062 3.46546 0.484598 3.13808 0.868897 3.13808L11.515 3.13808L9.92359 1.46577C9.65177 1.18012 9.65177 0.717009 9.92359 0.431369C10.1954 0.145727 10.6361 0.145727 10.9079 0.431368L13.4263 3.0779C13.6337 3.2958 13.7377 3.58121 13.7383 3.86682C13.7383 3.86848 13.7383 3.87014 13.7383 3.8718Z",
    fill: "#8E9191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFlightSingle);
export default __webpack_public_path__ + "static/media/arrow-flight-single.ee0bb5f5cedcb758bd37ea860e832ddc.svg";
export { ForwardRef as ReactComponent };